import dayjs from 'dayjs';

export class DateValidator {
  static pastDateValidator(value: string): void {
    if (!value) return;

    if (dayjs().isAfter(value, 'date')) throw new Error('Please enter a future date to continue.');
  }

  static pastOrCurrentDateValidator(value: string): void {
    if (!value) return;

    if (dayjs().isBefore(value, 'date')) throw new Error('Please enter a current or past date.');
  }

  /** Validates that `value` is less than or equal to `targetDate`. */
  static maxDateValidator(value: string, targetDate?: string, targetLabel = 'target'): void {
    if (!value || !targetDate) return;

    if (dayjs(targetDate).isBefore(value, 'date'))
      throw new Error(`Date must be less than or equal to the ${targetLabel?.toLowerCase()} date.`);
  }
}
